import { Component, OnInit, ChangeDetectionStrategy, DOCUMENT, inject, input } from '@angular/core';
import { IconComponent } from '@teamfoster/sdk/icon';
import { ResizePipe } from '@teamfoster/sdk/image';
import { HighlightedArticle } from '../../models/disease-profile.model';

@Component({
  selector: 'app-highlighted-article',
  templateUrl: './highlighted-article.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, ResizePipe],
})
export class HighlightedArticleComponent implements OnInit {
  private document = inject(DOCUMENT);

  readonly article = input<HighlightedArticle>();

  squarePath =
    'M391.1 8.3c-133 0-282.6-44-365 89-24.5 39.5-26.6 145.2-10 271 25.6 193.3 18.4 205.9 79 246 55.7 36.8 92.6 20.2 275 23 181 2.8 227.2-14.7 294-57 60-38 90.2-121.1 75-209-20-116 60-194.8-27-297-75-88.2-188-66-321-66z';
  prettyPath = 'M219 60c165 0 208-30 325-55 176-37 233 130 210 223-56 227 13 343-258 407-259 29-413-87-475-218C-40 287 35 60 219 60z';

  ngOnInit(): void {}

  get path() {
    return (this.article()?.text || '').length < 600 ? this.prettyPath : this.squarePath;
  }
}
